// actionTypes.js
export const SET_VALUE_ModeleInvestissement = "SET_VALUE_ModeleInvestissement";
export const SET_TYPE_ModeleInvestissement = "SET_TYPE_ModeleInvestissement";
export const SET_CURRENT_PAGE_ModeleInvestissement =
  "SET_CURRENT_PAGE_ModeleInvestissement";
export const SET_ORDER_ModeleInvestissement = "SET_ORDER_ModeleInvestissement";
export const SET_SORT_FIELD_ModeleInvestissement =
  "SET_SORT_FIELD_ModeleInvestissement";
export const SET_ACTIF_ModeleInvestissement = "SET_ACTIF_ModeleInvestissement";
export const SET_CATEGORIE_ModeleInvestissement =
  "SET_CATEGORIE_ModeleInvestissement";
